(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["td-mobile-menu"] && !Shopify.designMode) return;
  try {
    (function() {
    const mobileMenu = document.getElementById('mobile-menu-drawer');
    if (!mobileMenu) return;

    mobileMenu.addEventListener('mobile-nav:open', function() {
      // Focus the close button after the drawer animation starts
      setTimeout(function() {
        const closeButton = mobileMenu.querySelector('.drawer__close-button');
        if (closeButton) {
          closeButton.focus();
        }
      }, 200);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
